import axiosClient from "./axiosClient";

// Admin chương trình Xu (Điểm danh / Nhiệm vụ / Hạng) — backend routes/admin-xu-program-route.js
const BASE = "/admin-xu-program";

const xuProgramApi = {
    getSettings() {
        return axiosClient.get(`${BASE}/settings`);
    },
    saveFlags(flags: Record<string, unknown>) {
        return axiosClient.put(`${BASE}/flags`, flags);
    },
    saveConfig(config: Record<string, unknown>) {
        return axiosClient.put(`${BASE}/config`, config);
    },
    // Gợi ý tài khoản: q rỗng = admin/mod; số = userId; chữ = tên/email bắt đầu bằng q
    suggestUsers(q: string) {
        return axiosClient.get(`${BASE}/users/suggest`, { params: { q } });
    },
    listParticipants(params: { sort?: string; tier?: number; q?: string; page?: number; beta?: number }) {
        return axiosClient.get(`${BASE}/participants`, { params });
    },
    getUser(userId: number | string) {
        return axiosClient.get(`${BASE}/users/${userId}`);
    },
    getLedger(userId: number | string, cursor?: string | null) {
        return axiosClient.get(`${BASE}/users/${userId}/ledger`, { params: cursor ? { cursor } : {} });
    },
    adjust(userId: number | string, body: { delta: number; note: string; clientUuid: string }) {
        return axiosClient.post(`${BASE}/users/${userId}/adjust`, body);
    },
    recomputeRank(userId: number | string) {
        return axiosClient.post(`${BASE}/users/${userId}/rank/recompute`);
    },
    revokeLedger(ledgerId: number | string, note: string) {
        return axiosClient.post(`${BASE}/ledger/${ledgerId}/revoke`, { note });
    },
    getStats(from: string, to: string) {
        return axiosClient.get(`${BASE}/stats`, { params: { from, to } });
    },
    // Số liệu mở rộng: tham gia, giữ chân, phễu nhiệm vụ, kinh doanh, chi phí Xu
    getStatsOverview(from: string, to: string) {
        return axiosClient.get(`${BASE}/stats/overview`, { params: { from, to } });
    },
    getSuspicious(days = 7) {
        return axiosClient.get(`${BASE}/suspicious`, { params: { days } });
    },
};

export default xuProgramApi;
